import { z } from 'zod';

export const changePasswordSchema = z.object({
  oldPassword: z
    .string()
    .min(6, "L'ancien mot de passe est requis")
    .nonempty("L'ancien mot de passe est requis"),

  newPassword: z
    .string()
    .min(8, "*Le mot de passe doit contenir au moins 8 caractères.")
    .regex(/[a-z]/, "*Le mot de passe doit contenir au moins une lettre minuscule.")
    .regex(/[A-Z]/, "*Le mot de passe doit contenir au moins une lettre majuscule.")
    .regex(/[0-9]/, "*Le mot de passe doit contenir au moins un chiffre.")
    .regex(/\W|_/, "*Le mot de passe doit contenir au moins un caractère spécial."),

  confirmPassword: z
    .string()
    .min(8, "*Le mot de passe doit contenir au moins 8 caractères.")
    .nonempty("La confirmation du mot de passe est requise"),

})
  .refine((data) => data.newPassword === data.confirmPassword, {
    path: ["confirmPassword"],
    message: "*Les mots de passe ne correspondent pas.",
  });